import { GenericProvider } from '@/features/game-context/types.ts';
import {
  OutboundPayload,
  PROVIDER_ADAPTORS,
} from '@/features/game-window-integration/providers/generic-provider/payload-adaptors';
import {
  ExtendableGenericEvents,
  GenericEvents,
  GenericEventsData,
} from '@/features/game-window-integration/providers/generic-provider/types.ts';

export const isGenericProvider = (provider: unknown) =>
  Object.values(GenericProvider).some((value) => value === provider);

export const remapEvent = (
  provider: GenericProvider,
  event: GenericEvents,
): ExtendableGenericEvents =>
  PROVIDER_ADAPTORS[provider]?.eventsRemap[event] ?? event;

/** Adaptor for incoming messages from provider */
export const providerEventDataAdaptor = (
  provider: GenericProvider,
  providerData: GenericEventsData,
): GenericEventsData => PROVIDER_ADAPTORS[provider]?.adaptInbound(providerData);

/** Adaptor for outgoing messages to provider */
export const payloadEventDataAdaptor = (
  provider: GenericProvider,
  payloadEventData: ExtendableGenericEvents,
  notify?: boolean,
  payload?: OutboundPayload,
): GenericEventsData | undefined =>
  PROVIDER_ADAPTORS[provider]?.adaptOutbound(payloadEventData, notify, payload);
